import { ALLOWED_JUSTIFIES, ALLOWED_SPACING_TOKENS, ALLOWED_STACK_ALIGNS, ALLOWED_STACK_OVERFLOWS, sanitizeAllowedString, sanitizeBoolean, sanitizePositiveInteger } from './helpers';
export function sanitizeStack(el, sanitizeElement) {
  if (!Array.isArray(el.children)) {
    return null;
  }
  const children = el.children.map(sanitizeElement).filter(child => child !== null);
  if (children.length === 0) {
    return null;
  }
  return {
    type: 'Stack',
    children,
    gap: sanitizeAllowedString(el.gap, ALLOWED_SPACING_TOKENS),
    padding: sanitizeAllowedString(el.padding, ALLOWED_SPACING_TOKENS),
    align: sanitizeAllowedString(el.align, ALLOWED_STACK_ALIGNS),
    justify: sanitizeAllowedString(el.justify, ALLOWED_JUSTIFIES),
    grow: sanitizeBoolean(el.grow),
    overflow: sanitizeAllowedString(el.overflow, ALLOWED_STACK_OVERFLOWS),
    maxWidth: sanitizePositiveInteger(el.maxWidth),
    maxHeight: sanitizePositiveInteger(el.maxHeight),
    border: sanitizeBoolean(el.border)
  };
}